import React from 'react';
import { Box } from '@mui/material';
import CvSectionEditor from './CvSectionEditor';
import CvPreview from './CvPreview';
export default function CvEditorView({
  cvData,
  documentLanguage = 'es',
  updateCvData,
  onDownload,
  downloading
}) {
  return <Box className="cv-editor-layout"><Box className="cv-editor-column"><CvSectionEditor data={cvData} updateCvData={updateCvData} /></Box><Box className="cv-desktop-preview"><CvPreview documentLanguage={documentLanguage} data={cvData} onDownload={onDownload} downloading={downloading} /></Box></Box>;
}
